import React from 'react';
import DiscardConfirmation, {
  useDiscardConfirmation,
} from 'components/DiscardConfirmation';
// Slices
import { checkDisable } from 'slices/dynamicAvailability.slice';
import { useAppDispatch } from 'slices/store';
import { DefaultContentLayout } from '@timeedit/ui-components';
import intl from '../../../i18n/intl';
import DynamicAvailabilityDrawer from './DynamicAvailabilityDrawer';
// Components
import DynamicAvailabilityTable from './DynamicAvailabilityList';

const language: any = intl.messages;

type Props = {};

const DynamicAvailabilityPage: React.FC<Props> = () => {
  const dispatch = useAppDispatch();
  const [
    openDiscardDialog,
    onCloseDiscardDialog,
    confirmFn,
    confirmDiscardChanged,
  ] = useDiscardConfirmation();

  const confirmDiscardPaddingChanges = React.useCallback(
    (isFirstDrawer: boolean, actionFn: () => void) => {
      const isFieldRelationDisabled = dispatch(checkDisable(isFirstDrawer));
      if (!isFieldRelationDisabled) {
        return confirmDiscardChanged(actionFn);
      }
      actionFn();
    },
    []
  );

  return (
    <DefaultContentLayout
      title={language.dynamic_availability_title}
      subtitle={language.dynamic_availability_subtitle}
    >
      <div className="inner-content--wrapper">
        <DynamicAvailabilityTable
          confirmDiscardPaddingChanges={confirmDiscardPaddingChanges}
        />
        <DynamicAvailabilityDrawer
          confirmDiscardPaddingChanges={confirmDiscardPaddingChanges}
        />
      </div>
      <DiscardConfirmation
        open={openDiscardDialog}
        onClose={onCloseDiscardDialog}
        confirmFn={confirmFn}
      />
    </DefaultContentLayout>
  );
};

export default DynamicAvailabilityPage;
